import { render, staticRenderFns } from "./cata-item.vue?vue&type=template&id=6eb382b6&scoped=true&"
import script from "./cata-item.vue?vue&type=script&lang=js&"
export * from "./cata-item.vue?vue&type=script&lang=js&"
import style0 from "./cata-item.vue?vue&type=style&index=0&id=6eb382b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb382b6",
  null
  
)

export default component.exports